// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zindex-on[data-v-5ff06692]{z-index:1150}.zindex-auto[data-v-5ff06692]{z-index:auto}.flex-container[data-v-5ff06692]{line-height:inherit!important;height:inherit!important;font-size:inherit}[data-v-5ff06692] .icon{color:inherit;vertical-align:baseline}[data-v-5ff06692] em{vertical-align:middle;font-style:normal}[data-v-5ff06692] .btn.btn-link,[data-v-5ff06692] em{color:inherit}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
